const config = {
    name: 'World of DEIF',
    // Default languagecode (determines what json file to fetch from assets/json/@lang/manifest.json)
    defaultLanguage: 'en',

    // When changing this property, you should close the browser session as the route can be sent into an endless loop.
    includeLanguageCodeInUrl: false,

    mediaFolder: './media',
    manifest: 'assets/json/@lang/manifest.json',
    externalManifest: '/external/manifest.json',
    externalMediaFolder: '/external/media',
}

// for local dev environment on network
const ipRegex = /^(?:[0-9]{1,3}\.){3}[0-9]{1,3}$|^(?:[A-Fa-f0-9]{1,4}:){7}[A-Fa-f0-9]{1,4}$|^(?:[A-Fa-f0-9]{1,4}:){6}:[A-Fa-f0-9]{1,4}$|^(?:[A-Fa-f0-9]{1,4}:){5}(?::[A-Fa-f0-9]{1,4}){1,2}$|^(?:[A-Fa-f0-9]{1,4}:){4}(?::[A-Fa-f0-9]{1,4}){1,3}$|^(?:[A-Fa-f0-9]{1,4}:){3}(?::[A-Fa-f0-9]{1,4}){1,4}$|^(?:[A-Fa-f0-9]{1,4}:){2}(?::[A-Fa-f0-9]{1,4}){1,5}$|^[A-Fa-f0-9]{1,4}:(?::[A-Fa-f0-9]{1,4}){1,6}$|^:(?::[A-Fa-f0-9]{1,4}){1,7}$|^:(?::[A-Fa-f0-9]{1,4}){0,6}:[A-Fa-f0-9]{1,4}$|^(?:[0-9]{1,3}\.){3}[0-9]{1,3}$|^(?:[0-9a-fA-F]{0,4}:){1,8}:?$/


// LOCAL DEV ENVIRONMENT
if (window.location.hostname === "localhost" || ipRegex.test(window.location.hostname) || window.location.hostname === "bs-local.com") {
    config.manifest = 'https://deifv13frontdoor-h2huhdchb7aaedef.a03.azurefd.net/event/assets/json/@lang/manifest.json';
    config.mediaFolder = 'https://deifv13frontdoor-h2huhdchb7aaedef.a03.azurefd.net/event/media';
    config.externalManifest = 'https://deifv13frontdoor-h2huhdchb7aaedef.a03.azurefd.net/external/manifest.json';
    config.externalMediaFolder = 'https://deifv13frontdoor-h2huhdchb7aaedef.a03.azurefd.net/external/media';

    
    // UMBRACO 13 TEST
} else if (window.location.hostname === "deif-umbraco-13-dyg5cedzgcfrc7dw.northeurope-01.azurewebsites.net") {
    config.externalManifest = 'https://deifv13frontdoor-h2huhdchb7aaedef.a03.azurefd.net/external/manifest.json';
    config.externalMediaFolder = 'https://deifv13frontdoor-h2huhdchb7aaedef.a03.azurefd.net/external/media';
    config.mediaFolder = '/media';


    // ELECTRON PACKAGE
} else if (window.location.hostname === "") {
    config.mediaFolder = 'media/';
    config.externalManifest = 'external/manifest.json';
    config.externalMediaFolder = 'external/media/';
}

export default config